/**
 * The drag payload carried by a layout tile in SectionVariantsFlyout. The canvas drop handler
 * (C3 — #22208) reads this to look up the matching PresentationSectionV2Option and build the
 * placed section via createPresentationNextSection.
 *
 * Look the catalog entry up by `optionKey` (stamped by getPresentationNextSectionOptions), not
 * `label` — label is not unique within a category (every "about" entry is literally titled
 * "About Us"). `label` is carried for display/fallback (`text/plain`) only.
 */
export interface PresentationSectionDragPayload {
  category: string
  optionKey: string
  label: string
}

/** Custom MIME type on the drag event's DataTransfer carrying the JSON-encoded payload above. */
export const PRESENTATION_SECTION_DRAG_MIME_TYPE = 'application/x-paintscout-presentation-section'

/** The `data-*` attribute C3's canvas drop zones use to tell a section drag from a block drag. */
export const PRESENTATION_SECTION_DRAG_KIND = 'section'

export function setSectionDragPayload(dataTransfer: DataTransfer, payload: PresentationSectionDragPayload) {
  dataTransfer.effectAllowed = 'copy'
  dataTransfer.setData(PRESENTATION_SECTION_DRAG_MIME_TYPE, JSON.stringify(payload))
  // fallback for any drop target that only reads plain text
  dataTransfer.setData('text/plain', payload.label)
}
